import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { ErrorHandler, NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { Router } from "@angular/router";
import { TraceService, createErrorHandler } from "@sentry/angular";
import { UserIdleModule } from "angular-user-idle";
import { environment } from "../../../environments/environment";
import { CoreModule } from "../../core/core.module";
import { SharedModule } from "../../shared/shared.module";
import { IndexModule } from "../index/index.module";
import { PortalModule } from "../portal/portal.module";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

@NgModule({
  declarations: [AppComponent],
  imports: [
    // App Routing
    AppRoutingModule,
    // Core Module
    CoreModule,
    // Shared Module
    SharedModule,
    // Index Module
    IndexModule,
    // Portal Module
    PortalModule,
    // Others Modules
    BrowserAnimationsModule,
    UserIdleModule.forRoot({ idle: environment.logoutInactivity, timeout: 1, ping: environment.logoutSilentRefresh }),
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: TraceService,
      deps: [Router],
    },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
